import { render, staticRenderFns } from "./RecoverPasswordGreetings.vue?vue&type=template&id=ae8b027e&scoped=true&"
import script from "./RecoverPasswordGreetings.vue?vue&type=script&lang=js&"
export * from "./RecoverPasswordGreetings.vue?vue&type=script&lang=js&"
import style0 from "./RecoverPasswordGreetings.vue?vue&type=style&index=0&id=ae8b027e&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ae8b027e",
  null
  
)

export default component.exports